// SB SHOW ON ESC
import useEventListener from "@use-it/event-listener";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
import styled, { css } from "styled-components";
import Bg from "./components/Bg";
import Cart from "./components/store/Cart";
import Menu from "./components/store/Menu";
import Navbar from "./components/store/Navbar";
import Popup from "./components/Popup";
import Preloader from "./components/Preloader.js";
import ProductList from "./components/store/ProductList";
import Tabbed from "./components/account/Tabbed";
import UserAccount, {
  Ex_UserAccountNoti
} from "./components/account/UserAccount";
import Account from "./components/account/Account";
import { ProductProvider, ProductConsumer, ProductContext } from "./context";
import SiteBuilder from "./sb/SiteBuilder";
import "./components/store/xsolla_shop.css";
import Store from "./components/store/Store";

import Uikit from "./components/uikit-b2c/Uikit";

import { themes, sections } from "./defaults";
import PS0 from "./components/ps/PS0";

const defaultList = 0;

// const defaultTheme = Math.floor(Math.random() * themes.length);
const defaultTheme = 3;

class App extends Component {
  state = {
    // psToken: 'k8pnptVIVZCTs7EMFDcRIrwX3CRpdA4q', //null
    psToken: null,
    currentPage: false,
    temp: false
  };

  getFromLocal = (what = 'xsollaBuilder') => {
    let data = localStorage.getItem(what);
    // debugger
    return Boolean(data) ? JSON.parse(data) : null;

  }


  componentWillUpdate(nextProps, nextState) {
    console.log("nextState.psToken = ", nextState.psToken);
  }

  render() {
    return (
      <ProductProvider
        sections={this.getFromLocal() ? this.getFromLocal()['sections'] : [...sections[defaultList]]}
        theme={this.getFromLocal() ? this.getFromLocal()['theme'] : { ...themes[defaultTheme] }}
        psSections={this.getFromLocal() ? this.getFromLocal()['psSections'] : null}
        userStyles={this.getFromLocal() ? this.getFromLocal()['style'] : null}
      >
        <Router>
          <ProductConsumer style={{ width: "100px" }}>
            {valueFromContext => {


              return (
                <CssBody theme={valueFromContext.getTheme()}>
                  {!this.state.temp && (
                    <Sb0>
                      {valueFromContext["sbShown"] && (
                        <SiteBuilder type={this.state["currentPage"]} />
                      )}
                    </Sb0>
                  )}

                  <CssStore0
                    sbShown={valueFromContext["sbShown"]}
                    theme={valueFromContext.getTheme()}
                  >
                    <Switch>
                      <Route exact path="/ex_purchases/:keyId">
                        {history => {
                          // if (!this.state.temp) this.setState({ temp: true });

                          valueFromContext["sbShown"] &&
                            valueFromContext.setStateFrom("sbShown", false);
                          return (
                            <Fragment>
                              <Tabbed
                                theme={valueFromContext.getTheme()}
                                history={history}
                                fullscreen={true}
                                temp={true}
                              />
                            </Fragment>
                          );
                        }}
                      </Route>

                      <Route exact path="/store/cart">
                        {history => {
                          this.state["currentPage"] !== "store" &&
                            this.setState({ currentPage: "store" });
                          return (
                            <Fragment>
                              <Navbar history={history} />
                              <Menu />
                              {/* {valueFromContext.psToken && <ProductList/>} */}
                              {valueFromContext.psToken &&
                                valueFromContext[
                                  "sections"
                                ].map((section, ind) => (
                                  <ProductList
                                    key={`list_${ind}`}
                                    blockOrder={ind}
                                  />
                                ))}

                              <Popup
                                sb={valueFromContext["sbShown"]}
                                title={() => <h3>Cart</h3>}
                                theme={valueFromContext.getTheme()}
                                handleClose={() => {
                                  history.history.push("/store");
                                }}
                              >
                                {valueFromContext.psToken && (
                                  <ProductList
                                    filter="in_cart"
                                    cardType="cart"
                                  />
                                )}
                              </Popup>
                            </Fragment>
                          );
                        }}
                      </Route>

                      {/* <Route exact path="/store/inventory">
                    {history => {
                      return (
                        <Fragment>
                          <Navbar history={history} />
                          <Menu />
                          {valueFromContext.psToken && (
                            <ProductList filter="is_favorite" />
                          )}
                        </Fragment>
                      );
                    }}
                  </Route> */}

                      <Route exact path="/ex_notifications">
                        {history => {
                          return (
                            <Fragment>
                              <Ex_UserAccountNoti />
                              {valueFromContext.psToken && <ProductList />}
                            </Fragment>
                          );
                        }}
                      </Route>

                      <Route
                        exact
                        path={'/user_account/:id'}
                      >{()=> {
                        this.state['currentPage'] !== 'account' && this.setState({currentPage: 'account'});
                        return (<Account />)
                      }}

                      </Route>

                      <Route exact path={["/store/", "/store/:id"]}>
                        {history => {
                          this.state["currentPage"] !== "store" &&
                            this.setState({ currentPage: "store" });
                          return (
                            <Fragment>
                              <Store />
                            </Fragment>
                          );
                        }}
                      </Route>

                      <Route exact path="/choose">
                        {({history}) => {

                          this.state["currentPage"] &&
                            this.setState({ currentPage: false });
                          return (
                            <div
                              style={{
                                position: "relative",
                                zIndex: 100,
                                left: 0,
                                right: 0,
                                height: "90vh",
                                flexDirection: "column",
                                fontSize: "2em",
                                lineHeight: "2em",
                                top: 0,
                                bottom: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/store"
                                >
                                  Store
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/user_account/profile"
                                >
                                  User Account
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/ps/cart"
                                >
                                  Pay Station
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/uikit"
                                >
                                  B2C Customizable UI-kit
                                </Link>
                              </p>
                              <Bg style={{ zIndex: -1 }} />
                            </div>
                          );
                        }}
                      </Route>

                      <Route exact path="/">
                        {({history}) => {

                          history.push('/ps/cart');

                          this.state["currentPage"] &&
                            this.setState({ currentPage: false });
                          return (
                            <div
                              style={{
                                position: "relative",
                                zIndex: 100,
                                left: 0,
                                right: 0,
                                height: "90vh",
                                flexDirection: "column",
                                fontSize: "2em",
                                lineHeight: "2em",
                                top: 0,
                                bottom: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/store"
                                >
                                  Store
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/user_account/profile"
                                >
                                  User Account
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/ps/cart"
                                >
                                  Pay Station
                                </Link>
                              </p>
                              <p>
                                <Link
                                  style={{
                                    color: valueFromContext.getTheme()[
                                      "colorText"
                                    ]
                                  }}
                                  to="/uikit"
                                >
                                  B2C Customizable UI-kit
                                </Link>
                              </p>
                              <Bg style={{ zIndex: -1 }} />
                            </div>
                          );
                        }}
                      </Route>

                      <Route exact path="/uikit">
                        {hist => {
                          this.state['currentPage'] !== 'uikit' && this.setState({currentPage: 'uikit'});
                          return (
                            <Uikit
                              history={hist}
                              theme={valueFromContext.getTheme()}
                            />
                          );
                        }}
                      </Route>

                      <Route exact path={['/ps', '/ps/:keyId']}>
                        {({history, match}) => {
                          this.state['currentPage'] !== 'paystation' && this.setState({currentPage: 'paystation'});
                          return (
                            <PS0
                              psSections={valueFromContext["psSections"]}
                              history={history}
                              active={match.params['keyId']}
                              // activeMethod={match.params['keyId']}
                              theme={valueFromContext.getTheme()}
                            />
                          );
                        }}
                      </Route>





                    </Switch>

                    {/* {valueFromContext.fetching && <Preloader />} */}

                  </CssStore0>
                  <Bg plain z0/>
                </CssBody>
              );
            }}


            {/* <ProductList psToken='k8pnptVIVZCTs7EMFDcRIrwX3CRpdA4q' /> */}
          </ProductConsumer>
        </Router>
      </ProductProvider>
    );
  }
}

const CssBody = styled.div`



  @media (max-width: 991px) {
    font-size: 14px;
  }

  @media (max-width: 767px) {
    font-size: 14px;
  }

  @media (max-width: 479px) {
    font-size: 13px;
  }
  font-family: ${({ theme }) => Boolean(theme["fontFamily"]) ? theme["fontFamily"] : "Roboto"};
`;

export const Sb0 = ({ children }) => {
  const valueFromContext = React.useContext(ProductContext);

  const ESCAPE_KEYS = ["27", "Escape"];
  const handlerEsc = ({ key }) => {
    if (ESCAPE_KEYS.includes(String(key))) {
      valueFromContext.setStateFrom("sbShown", !valueFromContext.sbShown);
    }
  };
  useEventListener("keydown", handlerEsc);

  return (
    <CssSb0
      shown={valueFromContext["sbShown"]}
      onClick={() => {
        if (!valueFromContext["sbShown"])
          valueFromContext["setStateFrom"]("sbShown", true);
      }}
    >
      {children}
    </CssSb0>
  );
};

const CssSb0 = styled.div`
  ${({ shown }) =>
    shown &&
    css`
      background-color: #506373;
      color: #506373;
      height: 100vh;
      display: flex;
      position: relative;
    `};
  ${({ shown }) =>
    !shown &&
    css`
      width: 24px;
      height: 24px;
      right: 0;
      background: white;
      overflow: hidden;
      /* border: 10px solid red; */
      &::after {
        content: "↓";
        position: absolute;
        color: black;
        text-align: center;
        width: 100%;
      }
    `};
  position: fixed;
  z-index: 3;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (max-width: 479px) {
  }
`;

const CssStore0 = styled.div`
  height: 100vh;
  z-index: 1;
  /* font-family: ${({ theme }) =>
    theme["fontFamily"] ? theme["fontFamily"] : "Roboto"}; */
  position: relative;
  padding-top: ${({ sbShown }) => (sbShown ? "64px" : "0px")};
  padding-left: ${({ sbShown }) => (sbShown ? "320px" : "0px")};

  @media (max-width: 991px) {

  }

  @media (max-width: 767px) {
    padding-top: 0 !important;
    padding-left: 0 !important;
  }

  @media (max-width: 479px) {
    padding-left: 0 !important;
  }

`;

const CssCart = styled(Cart)`
  /* background-color: #506373; */
  left: 0;
  top: 0;
  height: 100vh;
  display: grid;
  align-items: center;
  position: relative;
  z-index: 100;
`;

export default App;
